<main class="overflow-auto h-full">
  @if (featureSupport$ | async; as featureSupport) {
    @if (featureSupport.groupedTable) {
    } @else {
      <ts-table
        #tsTable
        [relatedToRedirectConfig]="redirectConfig$ | async"
        [columnDefs]="columnDefs"
        [hasActionsColumn]="true"
        [hasCheckboxColumn]="featureSupport?.bulkActions?.enabled"
        [rowData]="data?.rows"
        rowSelection="multiple"
        [actions]="gridActions"
        [gridOptions]="options"
        [autoHeight]="false"
        [hasOpenDetailsColumn]="true"
        [autoHeight]="false"
        [loading]="loading()"
        [showCustomLoading]="true"
        (openDetails)="onOpenDetails($event)"
        (cellEditingStopped)="onCellEditingStopped($event)"
        (selectionChanged)="onSelectionChanged($event)"
        (onColumnMove)="onColumnMoved($event)"
        (sortChanged)="onSortChanged($event)"
        (gridReady)="onGridReady($event)"
      ></ts-table>
    }
  }
</main>

<footer class="flex justify-end items-center">
  <ts-paginator
    [totalItems]="data?.pageInfo?.filteredCount"
    [pageSize]="data?.pageInfo?.pageSize"
    [activePage]="data?.pageInfo?.currentPage"
    (pageChanged)="onPageChanged($event)"
  ></ts-paginator>
</footer>
